import { Injectable } from "@angular/core";
import { CoreHttpClient, Jurisdiction } from "@obg/ngx.core";
import { ContentConfigService } from "@obg/ngx.core.content";
import { Observable } from "rxjs";

import { CashDeskResponse } from "../cash-desk/cash-desk.model";
import { CommonContentResponse } from "../common-content/common-content.model";

import { CommonContentConfigService } from "./common-content.config";

@Injectable({
	providedIn: "root",
})
export class CommonContentClient {
	constructor(
		private client: CoreHttpClient,
		private commonContentConfig: CommonContentConfigService,
		private contentConfig: ContentConfigService
	) {}

	getCashDesks(): Observable<CashDeskResponse> {
		return this.client.get<CashDeskResponse>({
			url: this.commonContentConfig.getCashDeskEndpoint(),
		});
	}

	getCommonContent(
		documentName: string,
		searchParams?: { isLoggedIn: boolean; jurisdiction: Jurisdiction | string | undefined }
	): Observable<CommonContentResponse> {
		return this.client.get<CommonContentResponse>({
			url: `${this.contentConfig.getFilteredContentEndpoint()}/${documentName}`,
			searchParams,
		});
	}
}
